import { render, staticRenderFns } from "./row-card.vue?vue&type=template&id=65882fdd&scoped=true&"
import script from "./row-card.vue?vue&type=script&lang=ts&"
export * from "./row-card.vue?vue&type=script&lang=ts&"
import style0 from "./row-card.vue?vue&type=style&index=0&id=65882fdd&lang=scss&scoped=true&"
import style1 from "./row-card.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65882fdd",
  null
  
)

export default component.exports